import { InteractiveContainer } from "@jugl-web/ui-kit";
import React from "react";
import { ReactComponent as TextIcon } from "../../assets/text.svg";
import { AutomationVariableListItem } from "../../types";

type VariableListItemProps = {
  item: AutomationVariableListItem;
  description?: string;
  onClick: (id: string) => void;
};

export const VariableListItem: React.FC<VariableListItemProps> = ({
  item,
  description,
  onClick,
}) => (
  <InteractiveContainer
    className="flex flex-col gap-1 rounded-lg bg-white py-3 px-2"
    onClick={() => onClick(item.id)}
  >
    <div className="flex items-center gap-2">
      <div className="bg-primary-50 flex h-5 w-5 shrink-0 items-center justify-center rounded">
        <TextIcon />
      </div>
      <span className="text-dark font-secondary truncate text-sm font-medium leading-[21px]">
        {item.value.label}
      </span>
    </div>
    {description && (
      <span className="text-dark-600 font-secondary jugl__break-word text-sm leading-[21px]">
        {description}
      </span>
    )}
  </InteractiveContainer>
);
